import * as ds from '@attain-apps/fe/web/main/lib/design'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as me from '../../../me'
import type * as schema from '../../schema'
import type { Collection } from '../collection'

/**
 * Triggers DMS schema loading when a table refresh action is explicitly invoked
 * by the user.
 */
export const triggerSchemaLoadOnTableRefresh = store.effects.create(
  (
    _feature: Collection['feature'],
    collection: Collection,
    schemaFeature: schema.Feature,
    meFeature: me.Feature,
  ) =>
    collection.plugins.currentListPlugin.feature.actions.load.request
      .observe()
      .pipe(
        rxjs.filter(action =>
          ds.table.models.Status.Refresh.isTriggeredAction(action),
        ),
        rxjs.withLatestFrom(
          meFeature.contexts.selectors.zoneContext.asObservable,
        ),
        rxjs.map(([action, context]) =>
          context
            ? schemaFeature.actions.loadSchema.from(action).create({ context })
            : store.effects.SKIP,
        ),
      ),
)
